import { endPoints } from "../../constant/api_constants/url";
import { API_METHODS } from "../../enums";
import { fetchApi } from "../../utils/apiFunction";
import { consoleLog } from "../../utils/consoleLog/consoleLog";
import { recordCurrencyFromPriceReview } from "../../utils/searchCurrency";

export const promoReviewCart = async (accessJWT: string, requestBody: any) => {
  const hasHotels = Array.isArray(requestBody?.hotels) && requestBody.hotels.length > 0;
  const finalBody = {
    ...(hasHotels ? { version: "v2" } : {}),
    ...requestBody,
  };
  consoleLog(["API REQUEST", endPoints.priceReview, finalBody]);
  const response = await fetchApi(accessJWT, endPoints.priceReview, API_METHODS.POST, finalBody, null);
  consoleLog(["API RESPONSE", endPoints.priceReview, response]);
  // V2 chat-hotel diagnostic: the caller (useSelectRoomHooks) currently treats
  // any non-200 as `null`, hiding the real statusCode + message. Surface the
  // raw envelope here so the chat-driven failure mode is observable in console.
  // eslint-disable-next-line no-console
  console.log("[v2-FE-price-review-raw]", {
    statusCode: response?.statusCode,
    message: response?.message,
    error: response?.error,
    dataKeys: response?.data ? Object.keys(response.data) : null,
    raw: response,
  });
  if (response?.statusCode === 200) {
    recordCurrencyFromPriceReview(response);
    return response.data
  }
  else
    return null
};

export const getPromoDetails = async (accessJWT: string, requestBody: any) => {
  try {
    const response = await fetchApi(accessJWT, endPoints.getPromoCode, API_METHODS.POST, requestBody, null);
    consoleLog(["API RESPONSE", endPoints.getPromoCode, response]);
    return response;
  } catch (error) {
    consoleLog(["API ERROR", endPoints.getPromoCode, error]);
    return { statusCode: 500, data: null, error: "Failed to get promo details" };
  }
};
